"use client";

import { useClientRuntime } from "./use-client-runtime";

const startScrollReveal = () =>
  import("@tripcart/page-builder/scroll-reveal").then((m) =>
    m.startScrollReveal(window),
  );

/**
 * Starts the runtime that plays "Scroll into view" animations
 * (`@tripcart/page-builder/scroll-reveal`) on a published page, and stops it
 * on unmount. Until it runs, those animations play at page load and end at
 * rest, so a page is never left hidden waiting for it.
 *
 * Rendered only when the document holds one (`usesScrollReveal`).
 */
export function ScrollRevealLoader() {
  useClientRuntime(startScrollReveal);
  return null;
}
